import styled from '@emotion/styled';
import { LoadingButton } from '@eventbrite/marmalade';
import React from 'react';

export enum AuxilliaryActionBarTestIds {
    MainCTA = 'AuxilliaryActionBarMainCTA',
}

export const AuxilliaryActionBar = ({
    isSubmitting,
    primaryButtonText,
    onClick,
}: {
    isSubmitting?: boolean;
    primaryButtonText: string;
    onClick: () => void;
}) => {
    return (
        <Container>
            <div>
                <LoadingButton
                    disabled={isSubmitting}
                    isLoading={!!isSubmitting}
                    data-testid={AuxilliaryActionBarTestIds.MainCTA}
                    onClick={onClick}
                    variant={'primary'}
                >
                    {primaryButtonText}
                </LoadingButton>
            </div>
        </Container>
    );
};

const Container = styled.div`
    background: transparent;
    border-top: 1px solid #eeedf2;
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 16px 32px;
`;
